import React from 'react';
import { Helmet } from 'react-helmet';
import SeoSocialTags from '../components/SeoSocialTags';
import Hero from '../components/Hero';
import Features from '../components/Features';
import Integrations from '../components/Integrations';
import About from '../components/About';
import CTA from '../components/CTA';

const HOME_CANONICAL_URL = 'https://circumvent.io/';
const HOME_PAGE_TITLE = 'Circumvent | Security has a validation crisis';
const HOME_PAGE_DESCRIPTION =
  'Circumvent validates Cloud and AppSec findings. 95% noise reduction through contextual prioritization, grouping by action, and verdicts with evidence.';

const HomePage = () => (
  <main className="page page--light">
    <Helmet>
      <title>{HOME_PAGE_TITLE}</title>
      <meta name="description" content={HOME_PAGE_DESCRIPTION} />
      <link rel="canonical" href={HOME_CANONICAL_URL} />
    </Helmet>
    <SeoSocialTags
      title={HOME_PAGE_TITLE}
      description={HOME_PAGE_DESCRIPTION}
      url={HOME_CANONICAL_URL}
    />
    <Hero />
    <Features />
    <Integrations />
    <About />
    <CTA />
  </main>
);

export default HomePage;
